<app-perfil-shell
  [showGreeting]="false"
  [showSecurityBanner]="false"
  [skipFooterCms]="true"
  [hideSiteFooter]="true"
  [stickyHeader]="true"
  [compactBody]="true"
>
  <div class="solicitud-enviada">
    <div class="solicitud-enviada__content">
      <header class="solicitud-enviada__header">
        <h1 class="solicitud-enviada__title">{{ copy.titulo }}</h1>
        <p class="solicitud-enviada__subtitle solicitud-enviada__subtitle--mobile">
          {{ copy.subtitulo }}
        </p>
        <p class="solicitud-enviada__subtitle solicitud-enviada__subtitle--desktop">
          {{ copy.subtituloDesktop }}
        </p>
      </header>

      <div class="solicitud-enviada__pasos-block">
        <h2 class="solicitud-enviada__pasos-heading">{{ copy.pasosHeading }}</h2>

        <ul class="solicitud-enviada__steps" role="list">
          @for (paso of copy.pasos; track paso.id) {
          <li class="solicitud-enviada__card">
            <div class="solicitud-enviada__icon" aria-hidden="true">
              <img
                class="solicitud-enviada__icon-img"
                [src]="paso.icon"
                alt=""
                width="56"
                height="56"
              />
            </div>
            <div class="solicitud-enviada__card-text">
              <h3 class="solicitud-enviada__card-title">{{ paso.titulo }}</h3>
              <p class="solicitud-enviada__card-desc solicitud-enviada__card-desc--mobile">
                {{ paso.descripcion }}
              </p>
              <p class="solicitud-enviada__card-desc solicitud-enviada__card-desc--desktop">
                {{ paso.descripcionDesktop }}
              </p>
            </div>
          </li>
          }
        </ul>
      </div>

      <div class="solicitud-enviada__cta">
        <button
          type="button"
          class="solicitud-enviada__btn"
          id="btn-solicitud-enviada-inicio"
          (click)="onVolverInicio()"
        >
          {{ copy.ctaInicio }}
        </button>
        <button
          type="button"
          class="solicitud-enviada__link"
          id="btn-solicitud-enviada-revisar"
          (click)="onRevisarSolicitud()"
        >
          {{ copy.ctaRevisar }}
        </button>
      </div>
    </div>

    <div class="solicitud-enviada__decor" aria-hidden="true">
      <img
        class="solicitud-enviada__monedas"
        src="assets/img/perfil/solicitud-enviada/monedas.png"
        alt=""
        width="193"
        height="123"
      />
    </div>
  </div>
</app-perfil-shell>
